import _extends from "@babel/runtime/helpers/esm/extends";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import Button from './Button';
import Icon from './Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";

const SocialIcon = _ref => {
  let {
    className,
    service,
    url,
    type = 'default'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className", "service", "url", "type"]);

  const theme = useTheme();
  return ___EmotionJSX(Button, _extends({
    url: url,
    css: /*#__PURE__*/_css({
      transition: `all ${theme.timing.base} ${theme.transition.bounce}`,
      transformOrigin: 'center center',
      '&:hover, &:focus': {
        transform: 'scale(1.1)'
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:SocialIcon;"),
    className: clsx('CK__SocialIcon', className),
    target: "_blank",
    rel: "noopener noreferrer nofollow",
    iconOnly: true,
    size: "small",
    type: type
  }, rest), ___EmotionJSX(Icon, {
    icon: service
  }));
};

export default SocialIcon;